// extracted by mini-css-extract-plugin
export default {"accordionContainer":"accordionContainer__xsHwL","expand":"expand__WKZh5","body":"body__3VE6h","icon":"icon__Jogs1","header":"header__1IQn0"};